import type { ApplicationFormState } from '../types'
import { useApplicationFormFieldActions } from './useApplicationFormFieldActions'
import { useApplicationFormRegistration } from './useApplicationFormRegistration'

type UseApplicationFormSubmissionArgs = {
  state: ApplicationFormState
}

export function useApplicationFormSubmission({ state }: UseApplicationFormSubmissionArgs) {
  const { getAddressParts, ...fieldActions } = useApplicationFormFieldActions({ state })
  const registration = useApplicationFormRegistration({
    getAddressParts,
    state
  })

  return {
    ...fieldActions,
    ...registration
  }
}
